module.exports = __webpack_public_path__ + "img/ch34.f39ab961.jpg";